/**
 * Runtime polyfills for APIs newer than the build target (esbuild only
 * transpiles syntax, not APIs). Needed for Safari/iOS < 15.4 and Chrome < 93,
 * which otherwise crash with "x.at is not a function" / "Object.hasOwn is not
 * a function" (see VIP-12034). Must stay the first import in main.js.
 */

/* eslint-disable no-extend-native */

if (!Array.prototype.at) {
  const at = function (index) {
    const length = this.length
    let relativeIndex = Math.trunc(index) || 0
    if (relativeIndex < 0) relativeIndex += length
    if (relativeIndex < 0 || relativeIndex >= length) return undefined
    return this[relativeIndex]
  }

  for (const constructor of [
    Array,
    String,
    ...(typeof Int8Array === 'undefined'
      ? []
      : [
          Int8Array,
          Uint8Array,
          Uint8ClampedArray,
          Int16Array,
          Uint16Array,
          Int32Array,
          Uint32Array,
          Float32Array,
          Float64Array
        ])
  ]) {
    if (!constructor.prototype.at) {
      Object.defineProperty(constructor.prototype, 'at', {
        value: at,
        writable: true,
        configurable: true
      })
    }
  }
}

if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    value: (object, property) =>
      Object.prototype.hasOwnProperty.call(Object(object), property),
    writable: true,
    configurable: true
  })
}
